import monitor from '@blaze-cms/plugin-monitor';
import serverMonitors from '@blaze-cms/plugin-monitor/src/server-monitors';
import sentry from '@blaze-cms/plugin-sentry/src/utils/browser';
import contentPlugin from './blaze-plugins/content';

export default function buildConfig(config) {
  serverMonitors('frontend', [sentry]); // If required environment not set, sentry will not log anything.

  config.plugins.set(monitor, {});

  // To set custom plugins into the project.
  config.plugins.set(contentPlugin, {});
  // eslint-disable-next-line no-param-reassign
  config.apollo = {
    ...config.apollo,
    disableUpload: true
  };
  return config;
}
